/**
 * Export a page's bitmap in page-local pixels, independent of the stage's
 * pan and zoom. Konva draws a node using its absolute transform during
 * toDataURL(), so the export crop must start at the page's absolute position
 * and its pixel ratio must cancel the (uniform) stage scale.
 */
export function pageOverlayCaptureOptions(page) {
    const position = page.getAbsolutePosition();
    const absoluteScale = page.getAbsoluteScale();
    const scale = Number(absoluteScale.x);
    const safeScale = Number.isFinite(scale) && scale > 0 ? scale : 1;

    return {
        x: position.x,
        y: position.y,
        width: page.width() * safeScale,
        height: page.height() * safeScale,
        pixelRatio: 1 / safeScale,
    };
}
